import { ReactElement } from 'react';
import { ContentBlock } from '../../../components/layout/ContentBlock';
import { ContentCard } from './styles';
import Title from './Title';
import Summary from './Summary';
import List from './List';

const Content = (): ReactElement => {
  return (
    <ContentBlock>
      <ContentCard>
        <Title />
        <Summary />
        <List />
      </ContentCard>
    </ContentBlock>
  );
};

export default Content;
